module.exports = __webpack_public_path__ + "img/left-quote.5db982f.svg";